import { EInvoiceListFilter } from '@features/eInvoicing/constants'

import { AttachmentFilterType } from '../enums/attachmentFiltertype'

interface AttachmentsApiFilter {
  type: AttachmentFilterType
  eInvoiceFilter?: EInvoiceListFilter
}

export const getAttachmentsApiFilter = (
  type: AttachmentFilterType,
  isShoeboxOrg = false,
  isEInvoicingOnly = false,
): AttachmentsApiFilter => {
  if (type === AttachmentFilterType.Blocked) {
    return { type: AttachmentFilterType.EDocument, eInvoiceFilter: EInvoiceListFilter.Blocked }
  }

  if (type === AttachmentFilterType.Approved) {
    return { type: AttachmentFilterType.EDocument, eInvoiceFilter: EInvoiceListFilter.Approved }
  }

  if (type === AttachmentFilterType.EDocument || type === AttachmentFilterType.All) {
    // E-invoicing-only orgs list approved e-invoices in their own tab, so they are kept out of this one
    const showApproved = isShoeboxOrg || !isEInvoicingOnly

    return {
      type,
      eInvoiceFilter: showApproved ? EInvoiceListFilter.Unblocked : EInvoiceListFilter.Pending,
    }
  }

  return { type }
}
